import { render } from "./OrderDetailsModal.vue?vue&type=template&id=5655ec76"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js"

import "./OrderDetailsModal.vue?vue&type=style&index=0&id=5655ec76&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__